/* eslint-disable */

import userManager from '../utils/userManager';

class Auth {
  static deauthenticateUserAndRedirect() {
    if (typeof (Storage) !== 'undefined') {
      const store = userManager.settings.userStore._store;
      store.removeItem('access_token');
    }
  }


  static getToken() {
    const store = userManager.settings.userStore._store;
    return store.getItem('access_token');
  }
}

export default Auth;
